import { Directive, ElementRef, Input, AfterViewInit, OnDestroy } from '@angular/core';

@Directive({
  selector: '[appShadowStyle]'
})
export class ShadowStyleDirective implements AfterViewInit, OnDestroy {
  @Input('appShadowStyle') cssText: string = '';
  private styleElement: HTMLStyleElement | null = null;

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    this.applyStyle();
  }

  ngOnDestroy() {
    if (this.styleElement && this.el.nativeElement.shadowRoot) {
      this.el.nativeElement.shadowRoot.removeChild(this.styleElement);
    }
  }

  private applyStyle() {
    const host: HTMLElement = this.el.nativeElement;

    if (host.shadowRoot) {
      // Clean up old style if it exists
      if (this.styleElement && host.shadowRoot.contains(this.styleElement)) {
        host.shadowRoot.removeChild(this.styleElement);
      }

      this.styleElement = document.createElement('style');
      this.styleElement.textContent = this.cssText;
      host.shadowRoot.appendChild(this.styleElement);
    }
  }
}
